<nz-modal [(nzVisible)]="isVisible" [nzTitle]="null" [nzContent]="modalContent" [nzFooter]="null">
  <ng-template #modalContent>
    <div class="modal-content">
      <div nz-row>
        <div nz-col nzSpan="8"></div>
        <div nz-col nzSpan="2" class="right">
          <img class="img-modal" src="./assets/images/icon/warning.svg" width="43" height="45" alt="Logo">
        </div>
        <div nz-col nzSpan="12">
          <div class="modal-text body-font-size">
            ไม่พบข้อมูลที่ค้นหา
          </div>
        </div>
      </div>
      <div class="btn-wrapper p-2" style="text-align: center;">
        <div class="btn-styles btn-blue text-center">
          <div class="txt">
            <button type="button" (click)="close()" class="body-font-size">ตกลง</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</nz-modal>